<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-0.75 -0.75 24 24"
    height="24"
    width="24"
  >
    <g>
      <path
        d="M21.09375 20.390625a1.40625 1.40625 0 0 1 -1.40625 1.40625H2.8125a1.40625 1.40625 0 0 1 -1.40625 -1.40625V2.109375A1.40625 1.40625 0 0 1 2.8125 0.703125h14.0625a1.3875 1.3875 0 0 1 0.984375 0.403125l2.8125 2.6999999999999997a1.396875 1.396875 0 0 1 0.421875 1.003125Z"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      ></path>
      <path
        d="m9.140625 10.3125 0 7.96875"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      ></path>
      <path
        d="m4.921875 14.296875 12.65625 0"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      ></path>
      <path
        d="M5.390625 6.5625h11.71875s0.46875 0 0.46875 0.46875V17.8125s0 0.46875 -0.46875 0.46875H5.390625s-0.46875 0 -0.46875 -0.46875V7.03125s0 -0.46875 0.46875 -0.46875"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      ></path>
      <path
        d="m4.921875 10.3125 12.65625 0"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>